import { render, staticRenderFns } from "./koulutuspaikan-arvioijat.vue?vue&type=template&id=0abae449&"
import script from "./koulutuspaikan-arvioijat.vue?vue&type=script&lang=ts&"
export * from "./koulutuspaikan-arvioijat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports